module.exports = __webpack_public_path__ + "df16ccda66752e03b4bd6f37f8e8a416.png";